export default {
    props: {
        task: {
            required: true
        }
    }
}
